<template>
  <span>{{LL}}</span>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DateString',
  props: {
    timestamp: {
      type: Object,
      required: true,
    },
  },
  computed: {
    LL() {
      return dayjs.unix(this.timestamp.seconds).format('MMMM D, YYYY');
    },
  },
};
</script>
